import React from 'react';
import styles from './ClaimHeader.module.css';
import { ChevronRight, Sparkles, UserRound } from 'lucide-react';

const ClaimHeader = ({ dataPoints = [], sessionState = {}, companyData = {}, summary = "" }) => {
  // Ensure dataPoints is an array
  const safeDataPoints = Array.isArray(dataPoints) ? dataPoints : [];
  const basePath = process.env.PUBLIC_URL || '';
  // console.log(safeDataPoints, 'safeDataPoints');
  // console.log(sessionState, 'sessionState');
  // console.log(companyData, 'companyData');
  // console.log(summary, 'summary');

  // Determine claimant name using dataPoints configuration
  // Priority 1: Find dataPoint with component='subheader' and format='username'
  let claimantNameDataPoint = safeDataPoints.find(
    dp => dp.component === 'subheader' && dp.format === 'username'
  );
  
  // Priority 2: If not found, find dataPoint with component='subheader' and business_key=true
  if (!claimantNameDataPoint) {
    claimantNameDataPoint = safeDataPoints.find(
      dp => dp.component === 'subheader' && dp.business_key === true
    );
  }
  
  // Extract claimant name from sessionState using the found dataPoint key
  const claimantName = claimantNameDataPoint 
    ? (sessionState[claimantNameDataPoint.key] || "Unknown")
    : (sessionState?.caseId || "Unknown");
  

  summary = summary || sessionState['ai_summary']
  // Filter dataPoints for subheader component, excluding the one used for claimantName
  const subheaderDataPoints = safeDataPoints
    .filter(dp => dp.component === 'subheader' && dp.key !== claimantNameDataPoint?.key)
    .sort((a, b) => (a.header_order || 0) - (b.header_order || 0));
    
    // Filter dataPoints for header stats (show_in_header === true)
    const headerStatsDataPoints = safeDataPoints
    .filter(dp => dp.show_in_header === true)
    .filter(dp => dp.key !== 'ai_summary' && dp.key !== 'caseId' && dp.key !== 'insuredName')
    .sort((a, b) => (a.header_order || 0) - (b.header_order || 0));
  
  // Get currency symbol from company data
  const currencySymbol = companyData.currency || 'IDR';
  
  // Format value based on dataPoint configuration
  const formatValue = (dataPoint, value) => {
    if (value === null || value === undefined) return 'N/A';
    
    switch (dataPoint.format) {
      case 'percentage':
        return `${(value * 100).toFixed(0)}%`;
      case 'currency':
        return `${currencySymbol} ${value.toLocaleString()}`;
      case 'text':
      case 'username':
      default:
        return value;
    }
  };
  
  // Format change indicator
  const formatChange = (changeConfig, sessionState) => {
    if (!changeConfig) return null;
    
    const changeValue = sessionState[changeConfig.key];
    const changeDirection = sessionState[changeConfig.changeDirection];
    
    if (changeValue === null || changeValue === undefined) return null;
    
    let formattedValue = changeValue;
    if (changeConfig.format === 'percentage') {
      formattedValue = `${changeValue.toFixed(1)}%`;
    }
    
    const arrow = changeDirection === 'positive' ? '▲' : '▼';
    const colorClass = changeDirection === 'positive' ? styles.changePositive : styles.changeNegative;
    
    return (
      <span className={colorClass}>
        {arrow}{formattedValue}
      </span>
    );
  };

  return (
    <div className={styles.card}>
      <div className={styles.claimHeader}>
        <div className={styles.userSection}>
          <div className={styles.userAvatar}>
            <UserRound size={30} color="#94a6ca" />
          </div>
          <div className={styles.userInfo}>
            <div className={styles.titleRow}>
              <h2 className={styles.claimTitle}>{claimantName}</h2>
              <a href="#" className={styles.moreDetailsLink}>
                More Details <span style={{ fontSize: '0.7rem' }}> <ChevronRight size={15} /> </span>
              </a>
            </div>
            <div className={styles.claimSubtitle}>
              {subheaderDataPoints.map((dp) => (
                <div key={dp.key} className={styles.subtitleItem}>
                  {dp.label} <span>{formatValue(dp, sessionState[dp.key])}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={styles.statsContainer} data-count={headerStatsDataPoints.length}>
          {headerStatsDataPoints.map((dp) => {
            // Determine if this stat has a change and get the direction
            const changeDirection = dp.change ? sessionState[dp.change.changeDirection] : null;
            const valueColorClass = changeDirection === 'positive' 
              ? styles.changePositive 
              : changeDirection === 'negative' 
                ? styles.changeNegative 
                : '';
            
            return (
              <div key={dp.key} className={styles.statItem}>
                <div className={styles.statLabel}>{dp.label}</div>
                <div className={`${styles.statValue} ${valueColorClass}`}>
                  {formatValue(dp, sessionState[dp.key])}
                  {dp.change && (
                    <span className={styles.changeIndicator}>
                      {' '}{formatChange(dp.change, sessionState)}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className={styles.alertBanner}>
        {/* <div className={styles.alertIcon}><Sparkles size={25} /></div> */}
        <div className={styles.alertIcon}>
            <img src={`${basePath}/assets/images/workbench/ai-star-icon-blue.png`} alt="star-icon" style={{ width: '30px', height: '30px' }} />
        </div>

        <div className={styles.alertContent}>
          <div className={styles.alertDescription} dangerouslySetInnerHTML={{ __html: summary && summary.length > 0 ? summary : 'Summary is being generated... <br/>Check back later' }}></div>
        </div>
      </div>
    </div>
  );
};

export default ClaimHeader;
